import React from "react";

const ConfirmationModal = ({
  isOpen,
  onClose,
  onConfirm,
  title,
  message,
  warningMessage,
  confirmText = "Confirm",
  cancelText = "Cancel",
  confirmButtonClass = "border border-red-300/70 text-red-400 hover:bg-red-50/10 dark:hover:bg-red-950/30",
  loading = false,
  children,
}) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
      <div className="bg-bg-70 rounded-xl border border-bd-50 p-6 max-w-md w-full mx-4 space-y-4">
        <h3 className="text-lg font-semibold text-fg-50">{title}</h3>

        {message && <p className="text-sm text-fg-60">{message}</p>}

        {warningMessage && (
          <div className="bg-yellow-500/10 border border-yellow-500/20 rounded-lg p-3">
            <p className="text-xs text-yellow-600 dark:text-yellow-400">
              {warningMessage}
            </p>
          </div>
        )}

        {children}

        {/* Right-aligned buttons matching BillingSettings style */}
        <div className="flex items-center justify-end gap-2 pt-2">
          <button
            onClick={onClose}
            disabled={loading}
            className="px-3 py-1.5 border border-bd-50 text-fg-50 hover:bg-bg-60 disabled:opacity-50 disabled:cursor-not-allowed rounded-full text-sm font-medium transition-colors"
          >
            {cancelText}
          </button>
          <button
            onClick={onConfirm}
            disabled={loading}
            className={`px-3 py-1.5 disabled:opacity-50 disabled:cursor-not-allowed rounded-full text-sm font-medium transition-colors ${confirmButtonClass}`}
          >
            {loading ? "Processing..." : confirmText}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmationModal;
